import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { FlowFooterBadgeDescriptor, FlowFooterState } from '../types/footer.types.js';

interface FlowFooterStoreState extends FlowFooterState {
  registerBadge: (descriptor: FlowFooterBadgeDescriptor) => void;
  unregisterBadge: (id: string) => void;
  updateBadge: (id: string, patch: Partial<Omit<FlowFooterBadgeDescriptor, 'id'>>) => void;
  setBadgeVisibility: (id: string, visible: boolean) => void;
}

export const useFlowFooterStore = create<FlowFooterStoreState>()(
  devtools(
    (set, get) => ({
      badges: {},

      registerBadge: (descriptor) => {
        const existing = get().badges[descriptor.id];
        if (existing) {
          console.warn(`[FlowFooterStore] registerBadge: replacing existing badge "${descriptor.id}"`);
        }
        set((state) => ({
          badges: { ...state.badges, [descriptor.id]: descriptor },
        }));
      },

      unregisterBadge: (id) => {
        set((state) => {
          const next = { ...state.badges };
          delete next[id];
          return { badges: next };
        });
      },

      updateBadge: (id, patch) => {
        const existing = get().badges[id];
        if (!existing) {
          console.warn(`[FlowFooterStore] updateBadge: unknown badge id "${id}"`);
          return;
        }
        set((state) => ({
          badges: {
            ...state.badges,
            [id]: { ...state.badges[id], ...patch } as FlowFooterBadgeDescriptor,
          },
        }));
      },

      setBadgeVisibility: (id, visible) => {
        if (!get().badges[id]) return;
        set((state) => ({
          badges: {
            ...state.badges,
            [id]: { ...state.badges[id], visible },
          },
        }));
      },
    }),
    { name: 'FlowFooterStore' }
  )
);
